import Cookies from 'js-cookie'

export const selectToken = () => Cookies.get('authToken')
